import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/app/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/layout.tsx\",\"import\":\"EB_Garamond\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-eb-garamond\"}],\"variableName\":\"ebGaramond\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-plus-jakarta-sans\"}],\"variableName\":\"plusJakartaSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/FloatingFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/WelcomePopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertProvider"] */ "/app/src/context/AlertContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/context/NextAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SavedCandidatesProvider"] */ "/app/src/context/SavedCandidatesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SavedVacanciesProvider"] */ "/app/src/context/SavedVacanciesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribedCompaniesProvider"] */ "/app/src/context/SubscribedCompaniesContext.tsx");
